import { useCallback, useEffect, useState } from 'react';
import {
	H2, InputField, Label, Spacer, Text
} from '@components';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import styles from './MobileSearch.module.scss';
import { APICallProps, INPUT_ICON_POS, YourLoadItem } from '@types';
import { useGetYourLoadsData } from '@api';
import { debounce } from 'lodash';
import { ChevronRight } from '@mui/icons-material';
import { useWithImpersonation } from '@hooks';


export const MobileSearch = () => {
	const [filterSearchValue, setFilterSearchValue] = useState<string>('');
	const { callGetYourLoadData } = useGetYourLoadsData();
	const [loads, setLoads] = useState<YourLoadItem[] | null>(null);
	const withImpersonation = useWithImpersonation('carrier');
	const debouncedFetch = useCallback(
		debounce((value: string) => {
			if (value.length <= 3) return
			const fetchProps: APICallProps = {};
			if (value.length > 3) { fetchProps['params'] = { 'filter[search]': value } }
			callGetYourLoadData(fetchProps)
				.then((res) => {
					if (res?.data?.data) {
						setLoads(res.data.data);
					}
				})
		}, 500),
		[]
	);

	const handleOnLoadClick = (load: YourLoadItem) => {
		window.location.href = withImpersonation(`${window.location.origin}/carrier/your-loads/${load.master_manifest.id}`);
	}

	useEffect(() => {
		debouncedFetch(filterSearchValue);
		return () => {
			debouncedFetch.cancel();
		};
	}, [filterSearchValue, debouncedFetch]);

	return (
		<div>
			<div className={styles.heading}>
				<SearchOutlinedIcon />
				<H2>Search</H2>
			</div>
			<Spacer size={20} />
			<InputField
				name={'search_load'}
				value={filterSearchValue}
				onChange={(e: any) => setFilterSearchValue(e.target.value)}
				placeholder={'Search reference or order #'}
				Icon={SearchOutlinedIcon}
				iconPos={INPUT_ICON_POS.RIGHT}
				className={styles.filterSearch}
				keepErrorSpace={false}
				autoComplete='off'
				onClearInput={() => {
					setFilterSearchValue('')
					setLoads(null)
				}}
			/>
			{
				loads ?
					loads.length > 0 ?
						<>
							<Spacer size={20} />
							<div className={styles.resultsHeading}>
								<Label text={'Search results'} />
							</div>
							{
								loads.map((load: YourLoadItem) => {
									return (
										<div
											className={styles.result}
											key={load.id}
											onClick={() => handleOnLoadClick(load)}
										>
											<Text text={load.shipment.reference} />
											<ChevronRight />
										</div>
									)
								})
							}
						</> :
						<div>
							<Spacer size={20} />
							<Text text={'No search results found.'} />
						</div>

					: null
			}
		</div>
	);
}
